import { MeasurementType } from '@/configuration/measurements/measurement-types'

export const MEASUREMENT_TYPES_REFERENCE_ALLOWED = [
    MeasurementType.WindingResistance,
    MeasurementType.IsolationImpedanceStator,
    MeasurementType.IsolationImpedanceRotor,
    MeasurementType.PartialDischarge,
]